var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"master scrollable about",class:_vm.isMarkdown?'markdown':''},[(_vm.showTopBar)?_c('TopBar',{attrs:{"back":"/plus","title":"A propos"}}):_vm._e(),_c('div',{staticClass:"wrapper",domProps:{"innerHTML":_vm._s(_vm.about_html)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }